module.exports = __webpack_public_path__ + "static/media/press07.3e69fcce.png";